// Modificación de la vista Inventario.vue para usar datos reales del backend
// Actualiza el componente para asegurar que funcione con cualquier usuario, no solo admin/demo

<template>
  <div class="inventario-container">
    <div class="row mb-4">
      <div class="col-12">
        <div class="card">
          <div class="card-header d-flex justify-content-between align-items-center">
            <h5 class="card-title mb-0">Gestión de Inventario</h5>
          </div>
          <div class="card-body">
            <!-- Barra superior -->
            <div class="d-flex flex-column flex-md-row justify-space-between align-start align-md-center mb-6 ga-3">
              <h1 class="text-h4">Gestión de Inventario</h1>
              <div class="d-flex flex-column flex-sm-row ga-2 ga-sm-4 align-start align-sm-center">
                <!-- Botones desktop -->
                <!-- Botón Nuevo Producto comentado - ya no es necesario ya que se gestiona desde el modal "Gestionar Productos"
                <v-btn
                  color="primary"
                  prepend-icon="mdi-plus"
                  @click="showNewItemModal"
                  class="create-product-btn d-none d-sm-flex"
                  data-tour="create-product"
                >
                  Nuevo Producto
                </v-btn>
                -->
                <v-btn
                  color="info"
                  prepend-icon="mdi-pencil"
                  @click="showManageProducts = true"
                  class="d-none d-md-flex"
                  
                >
                  Gestionar Productos
                </v-btn>
                <v-btn
                  color="info"
                  prepend-icon="mdi-shape-plus"
                  @click="showCategoryManagement = true"
                  class="d-none d-md-flex"
                  v-if="!isViewer"
                >
                  Gestionar Categorías
                </v-btn>
                <v-btn
                  color="success"
                  prepend-icon="mdi-file-excel"
                  @click="exportInventory"
                  :loading="exporting"
                  class="d-none d-sm-flex"
                >
                  Exportar
                </v-btn>
                
                <!-- Botones mobile -->
                <!-- Botón Nuevo Producto móvil comentado - ya no es necesario ya que se gestiona desde el modal "Gestionar Productos"
                <v-btn
                  color="primary"
                  icon="mdi-plus"
                  @click="showNewItemModal"
                  class="d-sm-none"
                  size="small"
                  data-tour="create-product"
                ></v-btn>
                -->
                <v-btn
                  color="info"
                  icon="mdi-pencil"
                  @click="showManageProducts = true"
                  class="d-md-none"
                  size="small"
                  title="Gestionar Productos"
                  v-if="!isViewer"
                ></v-btn>
                <v-btn
                  color="info"
                  icon="mdi-shape-plus"
                  @click="showCategoryManagement = true"
                  class="d-md-none"
                  size="small"
                  title="Gestionar Categorías"
                  v-if="!isViewer"
                ></v-btn>
                <v-btn
                  color="success"
                  icon="mdi-file-excel"
                  @click="exportInventory"
                  :loading="exporting"
                  class="d-sm-none"
                  size="small"
                  title="Exportar"
                ></v-btn>
              </div>
            </div>
            
            <!-- Filtros y búsqueda -->
            <v-card class="mb-6">
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6" md="3">
                    <v-text-field
                      v-model="searchQuery"
                      prepend-inner-icon="mdi-magnify"
                      label="Buscar"
                      hide-details
                      density="compact"
                      @update:model-value="debouncedSearch"
                      class="search-input"
                      data-tour="search-products"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-select
                      v-model="filters.category"
                      :items="availableCategories"
                      label="Categoría"
                      item-title="title"
                      item-value="value"
                      hide-details
                      density="compact"
                      clearable
                      @update:model-value="applyFilters"
                      class="create-category-btn"
                      data-tour="create-category"
                    >
                      <template v-slot:prepend>
                        <v-icon>mdi-shape</v-icon>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-select
                      v-model="filters.location_id"
                      :items="locationsForSelect"
                      label="Ubicación"
                      item-title="title"
                      item-value="value"
                      hide-details
                      density="compact"
                      clearable
                      @update:model-value="applyFilters"
                    >
                      <template v-slot:prepend>
                        <v-icon>mdi-map-marker</v-icon>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-select
                      v-model="filters.stockStatus"
                      :items="[
                        { title: 'Normal', value: 'normal' },
                        { title: 'Bajo', value: 'low' },
                        { title: 'Crítico', value: 'critical' },
                        { title: 'Exceso', value: 'excess' }
                      ]"
                      label="Estado"
                      hide-details
                      density="compact"
                      clearable
                      @update:model-value="applyFilters"
                    >
                      <template v-slot:prepend>
                        <v-icon>mdi-chart-bar</v-icon>
                      </template>
                    </v-select>
                  </v-col>
                </v-row>

                <!-- Filtros por claves GS1 (checklist GS1 4.3): GTIN, Lote, N° Serie, SSCC, Vencimiento -->
                <v-row class="mt-1" dense>
                  <v-col cols="12" sm="4" md="2">
                    <v-text-field v-model="filters.gtin" label="GTIN" prepend-inner-icon="mdi-barcode" hide-details density="compact" clearable></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4" md="2">
                    <v-text-field v-model="filters.lot_number" label="Lote (10)" hide-details density="compact" clearable></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4" md="2">
                    <v-text-field v-model="filters.serial_number" label="N° Serie (21)" hide-details density="compact" clearable></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4" md="2">
                    <v-text-field v-model="filters.sscc" label="SSCC (00)" hide-details density="compact" clearable></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4" md="2">
                    <v-text-field v-model="filters.expiry_from" label="Vence desde" type="date" hide-details density="compact" clearable></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4" md="2">
                    <v-text-field v-model="filters.expiry_to" label="Vence hasta" type="date" hide-details density="compact" clearable></v-text-field>
                  </v-col>
                </v-row>

                <!-- Switch para productos inactivos -->
                <v-row class="mt-2">
                  <v-col cols="12" md="4">
                    <!-- El stock en Zona de Recepción (pendiente de almacenar) y en
                         cuarentena NO interfiere con el inventario operativo -->
                    <v-switch
                      v-model="showReceptionStock"
                      color="teal"
                      label="Mostrar Productos en Recepción"
                      hide-details
                      density="compact"
                    ></v-switch>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-switch
                      v-model="showQuarantineStock"
                      color="orange"
                      label="Mostrar Productos en Cuarentena"
                      hide-details
                      density="compact"
                    ></v-switch>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-switch
                      v-model="showInactiveProducts"
                      color="warning"
                      label="Mostrar productos inactivos/eliminados"
                      hide-details
                      @update:model-value="applyFilters"
                    >
                      <template v-slot:prepend>
                        <v-icon>mdi-eye-off</v-icon>
                      </template>
                    </v-switch>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            
            <div v-if="loading" class="text-center py-4">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Cargando...</span>
              </div>
              <p class="mt-2">Cargando datos...</p>
            </div>
            
            <div v-else class="table-responsive">
              <ResponsiveDataTable
                :items="groupedInventory"
                :headers="headers"
                :loading="loading"
                class="elevation-1 inventario-table product-details"
                :items-per-page="15"
                :show-select="false"
                density="default"
                hover
                data-tour="product-info"
              >
                <template v-slot:no-data>
                  <div class="text-center py-4">
                    <v-icon icon="mdi-alert" color="warning" size="large"></v-icon>
                    <p class="text-subtitle-1 mt-2">{{ noDataMessage }}</p>
                  </div>
                </template>

                <!-- Columna de expansión -->
                <template v-slot:item.expand="{ item }">
                  <div v-if="item.isGroup && item.totalLots > 1" class="text-center">
                    <v-btn
                      :icon="isProductExpanded(item.product_id) ? 'mdi-minus' : 'mdi-plus'"
                      size="small"
                      variant="text"
                      color="primary"
                      @click="toggleProductExpansion(item.product_id)"
                    ></v-btn>
                  </div>
                  <div v-else-if="item.isLotDetail" class="ml-6">
                    <v-icon icon="mdi-subdirectory-arrow-right" size="small" color="grey"></v-icon>
                  </div>
                </template>

                <template v-slot:item.product_sku="{ item }">
                  <div :class="{ 'lot-detail': item.isLotDetail }">
                    {{ item.product_sku }}
                  </div>
                </template>

                <template v-slot:item.product_name="{ item }">
                  <div :class="{ 'lot-detail': item.isLotDetail }">
                    <span v-if="item.isGroup && item.totalLots > 1" class="font-weight-bold">
                      {{ item.product_name }}
                      <v-chip size="small" color="primary" variant="outlined" class="ml-2">
                        {{ item.totalLots }} lotes
                      </v-chip>
                      <v-chip v-if="item.es_dispositivo_medico" size="x-small" color="teal" variant="tonal" class="ml-1" title="Dispositivo médico (NT 226)">DM</v-chip>
                      <v-chip v-if="item.tipo_dm === 'implantable'" size="x-small" color="red" variant="tonal" class="ml-1" title="Implantable Anexo 1 NGT 247">Implantable</v-chip>
                    </span>
                    <span v-else-if="item.isLotDetail" class="text-caption text-medium-emphasis">
                      {{ item.lot_number ? `Lote: ${item.lot_number}` : 'Sin lote especificado' }}
                    </span>
                    <span v-else>
                      {{ item.product_name }}
                      <v-chip v-if="item.es_dispositivo_medico" size="x-small" color="teal" variant="tonal" class="ml-1" title="Dispositivo médico (NT 226)">DM</v-chip>
                      <v-chip v-if="item.tipo_dm === 'implantable'" size="x-small" color="red" variant="tonal" class="ml-1" title="Implantable Anexo 1 NGT 247">Implantable</v-chip>
                    </span>
                  </div>
                </template>

                <template v-slot:item.category="{ item }">
                  <div :class="{ 'lot-detail': item.isLotDetail }">
                    <span v-if="!item.isLotDetail">{{ item.category }}</span>
                  </div>
                </template>

                <template v-slot:item.quantity="{ item }">
                  <div :class="{ 'lot-detail': item.isLotDetail }">
                    <span v-if="item.isGroup" class="font-weight-bold text-primary">
                      {{ item.quantity }}
                    </span>
                    <span v-else class="text-body-2">
                      {{ item.quantity }}
                    </span>
                  </div>
                </template>

                <template v-slot:item.location_code="{ item }">
                  <div :class="{ 'lot-detail': item.isLotDetail }">
                    {{ item.location_code }}
                  </div>
                </template>

                <template v-slot:item.stock_status_text="{ item }">
                  <div v-if="!item.isLotDetail">
                    <v-chip
                      :color="getStockStatusColor(item)"
                      text-color="white"
                      size="small"
                    >
                      {{ item.stock_status_text }}
                    </v-chip>
                  </div>
                </template>

                <template v-slot:item.actions="{ item }">
                  <div class="action-buttons">
                    <!-- Acciones para filas de grupo -->
                    <template v-if="item.isGroup">
                      <v-btn
                        icon="mdi-pencil"
                        size="small"
                        variant="text"
                        color="primary"
                        @click="editInventoryItem(item)"
                        title="Editar producto"
                      ></v-btn>
                    </template>
                    
                    <!-- Acciones para filas de detalle de lote -->
                    <template v-else-if="item.isLotDetail">
                      <v-btn
                        icon="mdi-eye"
                        size="small"
                        variant="text"
                        color="info"
                        @click="viewInventoryItem(item)"
                        title="Ver detalle del lote"
                      ></v-btn>
                      <v-btn
                        icon="mdi-arrow-up-down"
                        size="small"
                        variant="text"
                        color="success"
                        @click="showAdjustModal(item)"
                        title="Ajustar stock del lote"
                      ></v-btn>
                    </template>
                    
                    <!-- Acciones para productos individuales (sin agrupar) -->
                    <template v-else>
                      <v-btn
                        icon="mdi-eye"
                        size="small"
                        variant="text"
                        color="info"
                        @click="viewInventoryItem(item)"
                        title="Ver detalles"
                      ></v-btn>
                      <v-btn
                        icon="mdi-arrow-up-down"
                        size="small"
                        variant="text"
                        color="success"
                        @click="showAdjustModal(item)"
                        title="Ajustar stock"
                      ></v-btn>
                      <v-btn
                        icon="mdi-pencil"
                        size="small"
                        variant="text"
                        color="primary"
                        @click="editInventoryItem(item)"
                        title="Editar"
                      ></v-btn>
                    </template>
                  </div>
                </template>
              </ResponsiveDataTable>
            </div>
            
            <div class="pagination-container d-flex justify-content-between align-items-center mt-4">
              <div class="showing-info">
                Mostrando {{ groupedInventory.filter(item => item.isGroup).length }} productos ({{ filteredInventory.length }} items totales)
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Resumen de Inventario -->
    <v-row class="mb-4">
      <v-col cols="12" sm="6" md="3">
        <v-card class="dashboard-card">
          <v-card-text>
            <h6 class="text-subtitle-1">Total de Productos</h6>
            <div class="dashboard-value">{{ totalProducts }}</div>
            <div class="dashboard-subtitle">Productos registrados</div>
          </v-card-text>
        </v-card>
      </v-col>
      
      <v-col cols="12" sm="6" md="3">
        <v-card class="dashboard-card">
          <v-card-text>
            <h6 class="text-subtitle-1">Stock Total</h6>
            <div class="dashboard-value">{{ totalStock }}</div>
            <div class="dashboard-subtitle">Unidades en inventario</div>
          </v-card-text>
        </v-card>
      </v-col>
      
      <v-col cols="12" sm="6" md="3">
        <v-card class="dashboard-card">
          <v-card-text>
            <h6 class="text-subtitle-1">Categorías</h6>
            <div class="dashboard-value">{{ totalCategories }}</div>
            <div class="dashboard-subtitle">Tipos de productos</div>
          </v-card-text>
        </v-card>
      </v-col>
      
      <v-col cols="12" sm="6" md="3">
        <v-card class="dashboard-card alert-card">
          <v-card-text>
            <h6 class="text-subtitle-1">Stock Bajo o Crítico</h6>
            <div class="dashboard-value">{{ criticalStock }}</div>
            <div class="dashboard-subtitle">Productos con stock bajo o crítico</div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    
    <!-- Modal de Detalles de Producto -->
    <v-dialog v-model="showDetailDialog" max-width="800">
      <v-card>
        <v-card-title>Detalles del Producto</v-card-title>
        <v-card-text>
      <div v-if="selectedItem" class="modal-body">
            <v-row>
              <v-col cols="12" md="6">
            <div class="detail-group">
              <label>Código:</label>
              <p>{{ getProductSku(selectedItem.product_id) }}</p>
            </div>
            <div class="detail-group">
              <label>Nombre:</label>
              <p>{{ getProductName(selectedItem.product_id) }}</p>
            </div>
            <div class="detail-group">
              <label>Categoría:</label>
              <p>{{ getProductCategory(selectedItem.product_id) }}</p>
            </div>
            <div class="detail-group">
              <label>Descripción:</label>
              <p>{{ getProductDescription(selectedItem.product_id) }}</p>
            </div>
              </v-col>
              <v-col cols="12" md="6">
            <div class="detail-group">
              <label>Stock Actual:</label>
              <p>{{ selectedItem.quantity }}</p>
            </div>
            <div class="detail-group">
              <label>Ubicación:</label>
              <p>{{ getLocationName(selectedItem.location_id) }}</p>
            </div>
            <div class="detail-group">
              <label>Estado:</label>
              <p>
                    <v-chip :color="getStockStatusColor(selectedItem)" text-color="white">
                  {{ getStockStatus(selectedItem) }}
                    </v-chip>
              </p>
            </div>
            <div class="detail-group">
              <label>Última Actualización:</label>
              <p>{{ formatDate(selectedItem.updated_at) }}</p>
            </div>
              </v-col>
            </v-row>
        
            <v-row class="mt-4">
              <v-col cols="12">
            <h6>Información Adicional</h6>
                <v-table>
                <tbody>
                  <tr>
                    <th>Unidad de Medida</th>
                    <td>{{ getProductUnitOfMeasure(selectedItem.product_id) }}</td>
                  </tr>
                  <tr>
                    <th>Stock Mínimo</th>
                    <td>{{ getProductMinStock(selectedItem.product_id) }}</td>
                  </tr>
                  <tr>
                    <th>Stock Máximo</th>
                    <td>{{ getProductMaxStock(selectedItem.product_id) }}</td>
                  </tr>
                  <tr>
                    <th>Número de Lote</th>
                    <td>{{ selectedItem.lot_number || 'No especificado' }}</td>
                  </tr>
                  <tr>
                    <th>Peso</th>
                    <td>{{ getProductWeight(selectedItem.product_id) }} kg</td>
                  </tr>
                  <tr>
                    <th>Dimensiones (L x A x H)</th>
                    <td>{{ getProductDimensions(selectedItem.product_id) }}</td>
                  </tr>
                </tbody>
                </v-table>
              </v-col>
            </v-row>
            </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" variant="text" @click="showDetailDialog = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <!-- Modal de Edición de Producto -->
    <v-dialog v-model="showEditDialog" max-width="800">
      <v-card>
        <v-card-title>Editar Producto</v-card-title>
        <v-card-text>
      <div v-if="editingProduct" class="modal-body">
            <v-form ref="editForm">
              <v-text-field
                v-model="editingProduct.sku"
                label="Código"
                disabled
              ></v-text-field>
              
              <v-text-field
                v-model="editingProduct.name"
                label="Nombre"
                :rules="[v => !!v || 'El nombre es requerido']"
              ></v-text-field>
              
              <v-text-field
                v-model="editingProduct.category"
                label="Categoría"
                :rules="[v => !!v || 'La categoría es requerida']"
              ></v-text-field>
              
              <v-textarea
                v-model="editingProduct.description"
                label="Descripción"
                rows="3"
              ></v-textarea>
              
              <v-text-field
                v-model="editingProduct.unit_of_measure"
                label="Unidad de Medida"
              ></v-text-field>

              <!-- Dispositivo médico (NT 226 / NGT 247) -->
              <DmFieldsCard v-model="editingProduct" class="mb-4" />

              <!-- Unidad de despacho (caja) — checklist GS1 4.2 -->
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="editingProduct.case_gtin"
                    label="GTIN de la caja (unidad de despacho)"
                    maxlength="14"
                    :rules="editCaseGtinRules"
                    hint="Opcional: GTIN propio de la caja (distinto del unitario). En Egresos arma el pallet escaneando la caja"
                    persistent-hint
                    clearable
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model.number="editingProduct.units_per_case"
                    type="number"
                    label="Unidades por caja"
                    min="1"
                    :rules="editUnitsPerCaseRules"
                    clearable
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model.number="editingProduct.min_stock"
                    type="number"
                    label="Stock Mínimo"
                    min="0"
                    :rules="[v => v >= 0 || 'El stock mínimo debe ser mayor o igual a 0']"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model.number="editingProduct.max_stock"
                    type="number"
                    label="Stock Máximo"
                    min="0"
                    :rules="[v => v >= 0 || 'El stock máximo debe ser mayor o igual a 0']"
                  ></v-text-field>
                </v-col>
              </v-row>
              
              <!-- Dimensiones y peso -->
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model.number="editingProduct.weight"
                    type="number"
                    label="Peso (kg)"
                    min="0"
                    :rules="[v => !v || v > 0 || 'Si se especifica, el peso debe ser mayor a 0']"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model.number="editingProduct.length"
                    type="number"
                    label="Largo (cm)"
                    min="0"
                    :rules="[v => !v || v > 0 || 'Si se especifica, el largo debe ser mayor a 0']"
                  ></v-text-field>
                </v-col>
              </v-row>
              
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model.number="editingProduct.width"
                    type="number"
                    label="Ancho (cm)"
                    min="0"
                    :rules="[v => !v || v > 0 || 'Si se especifica, el ancho debe ser mayor a 0']"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model.number="editingProduct.height"
                    type="number"
                    label="Alto (cm)"
                    min="0"
                    :rules="[v => !v || v > 0 || 'Si se especifica, el alto debe ser mayor a 0']"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
            </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" variant="text" @click="showEditDialog = false">
            Cancelar
          </v-btn>
          <v-btn color="primary" @click="saveProduct" :disabled="!isEditFormValid">
            Guardar Cambios
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <!-- Modal de Ajuste de Inventario -->
    <v-dialog v-model="showAdjustDialog" max-width="600">
      <v-card>
        <v-card-title>Ajuste de Inventario</v-card-title>
        <v-card-text>
      <div v-if="selectedItem" class="modal-body">
        <div class="product-info mb-4">
          <h5>{{ getProductName(selectedItem.product_id) }}</h5>
              <p class="text-subtitle-2">Código: {{ getProductSku(selectedItem.product_id) }}</p>
          <p>Stock Actual: <strong>{{ selectedItem.quantity }}</strong></p>
          <p>Ubicación: <strong>{{ getLocationName(selectedItem.location_id) }}</strong></p>
        </div>
        
            <v-select
              v-model="adjustmentType"
              :items="[
                { title: 'Agregar', value: 'add' },
                { title: 'Restar', value: 'subtract' },
                { title: 'Establecer Valor', value: 'set' }
              ]"
              label="Tipo de Ajuste"
            ></v-select>
            
            <v-text-field
              v-model.number="adjustmentQuantity"
              type="number"
              label="Cantidad"
              min="1"
              :rules="[v => v >= 1 || 'La cantidad debe ser mayor a 0']"
            ></v-text-field>
            
            <v-select
              v-model="adjustmentReason"
              :items="[
                'Recepción',
                'Despacho',
                'Inventario Físico',
                'Devolución',
                'Merma',
                'Otro'
              ]"
              label="Motivo"
            ></v-select>
            
            <v-text-field
              v-if="adjustmentReason === 'Otro'"
              v-model="adjustmentReasonOther"
              label="Especificar Motivo"
              :rules="[v => !!v || 'Debe especificar el motivo']"
            ></v-text-field>
            
            <v-textarea
              v-model="adjustmentNotes"
              label="Notas"
              rows="2"
            ></v-textarea>
        </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" variant="text" @click="showAdjustDialog = false">
            Cancelar
          </v-btn>
          <v-btn color="primary" @click="applyAdjustment" :disabled="!isAdjustmentValid">
            Aplicar Ajuste
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <!-- Modal de Nuevo Producto -->
    <ProductDialog
      v-model="showNewProductDialog"
      :product="newProduct"
      mode="add"
      @save="saveNewProduct"
    />
    
    <!-- Modal de Confirmación de Eliminación -->
    <v-dialog v-model="showDeleteDialog" max-width="500">
      <v-card>
        <v-card-title class="text-h6 text-error">
          <v-icon color="error" class="mr-2">mdi-alert</v-icon>
          Confirmar Eliminación
        </v-card-title>
        <v-card-text>
          <p>¿Estás seguro de que deseas eliminar permanentemente el producto:</p>
          <div class="mt-2 pa-3 bg-grey-lighten-5 rounded">
            <strong>{{ itemToDelete?.product_name }}</strong>
            <br>
            <span class="text-caption">SKU: {{ getProductSku(itemToDelete?.product_id) }}</span>
          </div>
          <v-alert type="warning" class="mt-4" variant="tonal">
            <strong>¡Atención!</strong> Esta acción no se puede deshacer. Se eliminará el producto y todo su inventario asociado.
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" variant="text" @click="showDeleteDialog = false">
            Cancelar
          </v-btn>
          <v-btn 
            color="error" 
            @click="confirmDelete" 
            :loading="deleting"
          >
            Eliminar Permanentemente
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal: Gestionar Productos -->
    <v-dialog v-model="showManageProducts" max-width="1200" persistent>
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center">
          <span>Gestión de Productos</span>
          <v-btn
            icon="mdi-close"
            variant="text"
            @click="showManageProducts = false"
          ></v-btn>
        </v-card-title>
        <v-card-text>
                    <!-- Crear nuevo producto -->
          <v-card variant="outlined" class="mb-4">
            <v-card-title class="text-h6">Gestión de Productos</v-card-title>
            <v-card-text>
              <!-- Búsqueda -->
              <v-row class="mb-3">
                <v-col cols="12">
                  <v-text-field
                    v-model="manageSearch"
                    label="Buscar productos existentes"
                    placeholder="Buscar por nombre, SKU, categoría..."
                    prepend-inner-icon="mdi-magnify"
                    hide-details
                    density="compact"
                    clearable
                  ></v-text-field>
                </v-col>
              </v-row>
              
              <!-- Botones de acción -->
              <v-row v-if="!isViewer">
                <v-col cols="12" md="6">
                  <v-btn
                    color="primary"
                    block
                    prepend-icon="mdi-plus"
                    @click="createProductFromManagement"
                    size="large"
                  >
                    CREAR PRODUCTO
                  </v-btn>
                </v-col>
                <v-col cols="12" md="6">
                  <v-btn
                    color="success"
                    block
                    prepend-icon="mdi-file-excel"
                    @click="showBulkUpload = true"
                    size="large"
                  >
                    CARGAR EXCEL
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- Lista de productos existentes -->
          <v-card variant="outlined">
            <v-card-title class="text-h6">Productos Existentes</v-card-title>
            <v-card-text>
              <p class="text-caption text-grey-darken-1 mb-3">
                <v-icon size="small" class="mr-1">mdi-information</v-icon>
                Al eliminar un producto se eliminará también todo su inventario asociado. Esta acción no se puede deshacer.
              </p>
              <v-data-table
                :items="managedProducts"
                :headers="manageHeaders"
                :items-per-page="10"
                density="compact"
                class="elevation-1"
                :loading="loading"
              >
                <template v-slot:item.sku="{ item }">
                  <div class="d-flex align-center">
                    <v-icon class="mr-2" color="primary">mdi-package-variant</v-icon>
                    <span class="font-weight-medium">{{ item.sku }}</span>
                  </div>
                </template>
                
                <template v-slot:item.name="{ item }">
                  {{ item.name }}
                </template>

                <template v-slot:item.category="{ item }">
                  <v-chip size="small" color="info" v-if="item.category">
                    {{ item.category }}
                  </v-chip>
                  <span class="text-grey" v-else>Sin categoría</span>
                </template>

                <template v-slot:item.status="{ item }">
                  <v-chip 
                    size="small" 
                    :color="item.status === 'active' ? 'success' : 'error'"
                    text-color="white"
                  >
                    {{ item.status === 'active' ? 'Activo' : 'Inactivo' }}
                  </v-chip>
                </template>

                <template v-slot:item.actions="{ item }">
                  <v-btn
                    icon="mdi-pencil"
                    size="small"
                    variant="text"
                    color="primary"
                    @click="openEditProduct(item)"
                    title="Editar producto"
                  ></v-btn>
                  <v-btn
                    icon="mdi-delete"
                    size="small"
                    variant="text"
                    color="error"
                    @click="openDeleteProduct(item)"
                    title="Eliminar producto"
                  ></v-btn>
                </template>
                
                <template v-slot:no-data>
                  <div class="text-center py-4">
                    <v-icon size="48" color="grey">mdi-package-variant-plus</v-icon>
                    <p class="text-grey mt-2">No hay productos creados</p>
                  </div>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Modal: Carga Masiva desde Excel -->
    <v-dialog v-model="showBulkUpload" max-width="900" persistent>
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center">
          <span>Carga Masiva de Productos - Excel</span>
          <v-btn
            icon="mdi-close"
            variant="text"
            @click="closeBulkUpload"
          ></v-btn>
        </v-card-title>
        <v-card-text>
          <v-stepper v-model="uploadStep" hide-actions>
            <!-- Paso 1: Seleccionar archivo -->
            <v-stepper-header>
              <v-stepper-item value="1" title="Seleccionar Archivo"></v-stepper-item>
              <v-divider></v-divider>
              <v-stepper-item value="2" title="Validar Datos"></v-stepper-item>
              <v-divider></v-divider>
              <v-stepper-item value="3" title="Procesar"></v-stepper-item>
            </v-stepper-header>

            <v-stepper-window>
              <!-- Paso 1: Upload de archivo -->
              <v-stepper-window-item value="1">
                <v-card variant="outlined" class="mb-4">
                  <v-card-text>
                    <div class="text-center">
                      <v-icon size="64" color="success" class="mb-4">mdi-file-excel</v-icon>
                      <h3 class="mb-4">Seleccionar archivo Excel</h3>
                      
                      <v-alert type="info" variant="tonal" class="mb-4">
                        <div class="text-left">
                          <strong>Formato requerido:</strong>
                          <ul class="mt-2">
                            <li>3 columnas: <code>SKU</code>, <code>NOMBRE</code>, <code>CODIGO DE BARRAS</code></li>
                            <li>La primera fila debe contener los encabezados</li>
                            <li>Pueden existir múltiples filas con el mismo SKU (se deduplicará)</li>
                            <li>Códigos de barras pueden ser EAN/UPC simples o GS1 complejos</li>
                            <li>Si no hay código de barras, se generará automáticamente un EAN-13 único (T-logis)</li>
                          </ul>
                        </div>
                      </v-alert>

                      <v-file-input
                        v-model="uploadedFile"
                        accept=".xlsx,.xls"
                        label="Seleccionar archivo Excel"
                        prepend-icon="mdi-file-excel"
                        show-size
                        @update:model-value="processExcelFile"
                        clearable
                      ></v-file-input>
                    </div>
                  </v-card-text>
                </v-card>
              </v-stepper-window-item>

              <!-- Paso 2: Validar datos -->
              <v-stepper-window-item value="2">
                <v-card variant="outlined">
                  <v-card-title>Datos encontrados en Excel</v-card-title>
                  <v-card-text>
                    <v-alert type="success" variant="tonal" class="mb-4">
                      <strong>{{ processedProducts.length }}</strong> productos únicos encontrados de 
                      <strong>{{ excelData.length }}</strong> filas procesadas
                    </v-alert>

                    <v-data-table
                      :items="processedProducts"
                      :headers="previewHeaders"
                      density="compact"
                      class="elevation-1"
                      :items-per-page="10"
                      :items-per-page-options="[10, 25, 50, 100]"
                    >
                      <template v-slot:item.barcode_type="{ item }">
                        <v-chip size="small" :color="getBarcodeTypeColor(item.barcode_type)">
                          {{ item.barcode_type }}
                        </v-chip>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-stepper-window-item>

              <!-- Paso 3: Procesar -->
              <v-stepper-window-item value="3">
                <div class="text-center pa-8">
                  <v-progress-circular
                    v-if="processing"
                    indeterminate
                    color="primary"
                    size="64"
                    class="mb-4"
                  ></v-progress-circular>
                  <v-icon
                    v-else
                    size="64"
                    color="success"
                    class="mb-4"
                  >mdi-check-circle</v-icon>
                  
                  <h3>{{ processing ? 'Procesando productos...' : '¡Productos creados exitosamente!' }}</h3>
                  <p class="mt-2">{{ processing ? 'Por favor espere...' : `${processedProducts.length} productos han sido creados en el sistema.` }}</p>
                </div>
              </v-stepper-window-item>
            </v-stepper-window>
          </v-stepper>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="closeBulkUpload" :disabled="processing">
            {{ uploadStep === '3' && !processing ? 'Finalizar' : 'Cancelar' }}
          </v-btn>
          <v-btn 
            v-if="uploadStep === '2'"
            color="primary" 
            @click="createBulkProducts"
            :loading="processing"
          >
            Crear {{ processedProducts.length }} Productos
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal de Gestión de Categorías -->
    <v-dialog v-model="showCategoryManagement" max-width="800">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center">
          <span>Gestión de Categorías</span>
          <v-btn
            icon="mdi-close"
            variant="text"
            @click="showCategoryManagement = false"
          ></v-btn>
        </v-card-title>
        <v-card-text>
          <!-- Crear nueva categoría -->
          <v-card variant="outlined" class="mb-4">
            <v-card-title class="text-h6">Nueva Categoría</v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" md="8">
                  <v-text-field
                    v-model="newCategoryName"
                    label="Nombre de la categoría"
                    placeholder="Ej: Electrónicos, Ropa, Alimentación"
                    hide-details
                    density="compact"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-btn
                    color="primary"
                    block
                    @click="createNewCategory"
                    :loading="creatingCategory"
                    :disabled="!newCategoryName.trim()"
                  >
                    Crear Categoría
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- Lista de categorías existentes -->
          <v-card variant="outlined">
            <v-card-title class="text-h6">Categorías Existentes</v-card-title>
            <v-card-text>
              <p class="text-caption text-grey-darken-1 mb-3">
                <v-icon size="small" class="mr-1">mdi-information</v-icon>
                Solo se puede eliminar una categoría si no tiene productos asociados. Debe eliminar primero todos los productos de esa categoría.
              </p>
              <v-data-table
                :items="availableCategories"
                :headers="categoryHeaders"
                :items-per-page="10"
                density="compact"
                class="elevation-1"
              >
                <template v-slot:item.title="{ item }">
                  <div class="d-flex align-center">
                    <v-icon class="mr-2" color="primary">mdi-shape</v-icon>
                    {{ item.title }}
                  </div>
                </template>
                
                <template v-slot:item.productCount="{ item }">
                  <v-chip size="small" color="info">
                    {{ getProductCountByCategory(item.value) }} productos
                  </v-chip>
                </template>

                <template v-slot:item.status="{ item }">
                  <v-chip 
                    size="small" 
                    :color="item.id ? 'success' : 'warning'"
                    :text-color="item.id ? 'white' : 'black'"
                  >
                    {{ item.id ? 'Registrada' : 'Solo en productos' }}
                  </v-chip>
                </template>

                <template v-slot:item.actions="{ item }">
                  <v-btn
                    icon="mdi-pencil"
                    size="small"
                    variant="text"
                    color="primary"
                    @click="editCategory(item)"
                    :disabled="!item.id"
                    :title="!item.id ? 'Categoría no registrada en el sistema' : 'Editar categoría'"
                  ></v-btn>
                  <v-btn
                    icon="mdi-delete"
                    size="small"
                    variant="text"
                    color="error"
                    @click="deleteCategoryConfirm(item)"
                    :disabled="getProductCountByCategory(item.value) > 0 || !item.id"
                    :title="!item.id ? 'Categoría no registrada en el sistema' : 
                           getProductCountByCategory(item.value) > 0 ? 'No se puede eliminar: categoría en uso' : 'Eliminar categoría'"
                  ></v-btn>
                </template>
                
                <template v-slot:no-data>
                  <div class="text-center py-4">
                    <v-icon size="48" color="grey">mdi-shape-plus</v-icon>
                    <p class="text-grey mt-2">No hay categorías creadas</p>
                  </div>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Modal de Edición de Categoría -->
    <v-dialog v-model="showEditCategoryDialog" max-width="400">
      <v-card>
        <v-card-title>Editar Categoría</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="editingCategoryName"
            label="Nombre de la categoría"
            :rules="[v => !!v || 'El nombre es requerido']"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" variant="text" @click="showEditCategoryDialog = false">
            Cancelar
          </v-btn>
          <v-btn 
            color="primary" 
            @click="saveEditedCategory" 
            :loading="savingCategory"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
        </div>
</template>

<script setup>
import { ref, computed, onMounted, watch, onUnmounted } from 'vue'
import { useStore } from 'vuex'
import { useToast } from 'vue-toastification'
import { debounce } from 'lodash'
import ProductDialog from '@/components/inventory/ProductDialog.vue'
import DmFieldsCard from '@/components/inventory/DmFieldsCard.vue'
import ResponsiveDataTable from '@/components/ResponsiveDataTable.vue'
import { validateProductBarcode, isAI01Only } from '@/utils/gs1Validation'

// Store y toast
const store = useStore()
const toast = useToast()

// Computed para verificar rol del usuario
const currentUser = computed(() => store.getters['auth/currentUser'])
const isViewer = computed(() => currentUser.value?.role === 'viewer')

// Referencias
const editForm = ref(null)
const newProductForm = ref(null)

// Variables reactivas
const loading = ref(false)
const exporting = ref(false)
const deleting = ref(false)
const creatingCategory = ref(false)
const savingCategory = ref(false)
const searchQuery = ref('')
const selectedItem = ref(null)
const editingProduct = ref(null)

// Unidad de despacho (caja) — checklist GS1 4.2 (mismas reglas que ProductDialog)
const toG14Case = code => String(code || '').replace(/\D/g, '').padStart(14, '0')
const editCaseGtinRules = [v => {
  if (!v) return !editingProduct.value?.units_per_case ||
    'GTIN de la caja y unidades por caja van juntos'
  const r = validateProductBarcode(v)
  if (!r.valid) return r.message
  if (editingProduct.value?.barcode && toG14Case(v) === toG14Case(editingProduct.value.barcode))
    return 'Debe ser distinto del GTIN unitario: cada nivel de empaque lleva su propio GTIN'
  return true
}]
const editUnitsPerCaseRules = [v => {
  if (!v) return !editingProduct.value?.case_gtin ||
    'GTIN de la caja y unidades por caja van juntos'
  return (Number.isInteger(Number(v)) && Number(v) >= 1) || 'Entero mayor o igual a 1'
}]

const itemToDelete = ref(null)
const showDetailDialog = ref(false)
const showEditDialog = ref(false)
const showNewProductDialog = ref(false)
const showAdjustDialog = ref(false)
const showDeleteDialog = ref(false)
const showCategoryManagement = ref(false)
const showEditCategoryDialog = ref(false)
const showManageProducts = ref(false)
const showInactiveProducts = ref(false)
const inventoryUpdateInterval = ref(null)

// Estado para productos expandidos/colapsados
const expandedProducts = ref(new Set())

// Gestión de productos (modal)
const manageSearch = ref('')
const fromManageModal = ref(false) // Track if product creation comes from management modal

// Carga masiva desde Excel
const showBulkUpload = ref(false)
const uploadedFile = ref(null)
const excelData = ref([])
const processedProducts = ref([])
const uploading = ref(false)
const processing = ref(false)
const uploadStep = ref('1')

const previewHeaders = [
  { title: 'SKU', key: 'sku', align: 'start', sortable: true },
  { title: 'Nombre', key: 'name', align: 'start', sortable: true },
  { title: 'Código Barras', key: 'barcode', align: 'start', sortable: true },
  { title: 'Tipo', key: 'barcode_type', align: 'center', sortable: true }
]
const manageHeaders = computed(() => {
  const baseHeaders = [
    { title: 'SKU', key: 'sku', align: 'start', sortable: true },
    { title: 'Nombre', key: 'name', align: 'start', sortable: true },
    { title: 'Categoría', key: 'category', align: 'start', sortable: true },
    { title: 'Stock Min', key: 'min_stock', align: 'end', sortable: true },
    { title: 'Stock Max', key: 'max_stock', align: 'end', sortable: true },
    { title: 'Estado', key: 'status', align: 'center', sortable: true }
  ]
  
  // Solo agregar columna "Acciones" si no es visualizador
  if (!isViewer.value) {
    baseHeaders.push({ title: 'Acciones', key: 'actions', align: 'center', sortable: false })
  }
  
  return baseHeaders
})
const managedProducts = computed(() => {
  const all = productsFromStore.value || []
  const q = manageSearch.value?.toLowerCase().trim() || ''
  if (!q) return all
  return all.filter(p =>
    p.sku?.toLowerCase().includes(q) ||
    p.name?.toLowerCase().includes(q) ||
    p.category?.toLowerCase().includes(q) ||
    p.barcode?.toLowerCase().includes(q)
  )
})

// Gestión de categorías
const newCategoryName = ref('')
const editingCategoryName = ref('')
const editingCategory = ref(null)

const categoryHeaders = [
  { title: 'Categoría', key: 'title', sortable: true },
  { title: 'Productos', key: 'productCount', sortable: false },
  { title: 'Estado', key: 'status', sortable: false },
  { title: 'Acciones', key: 'actions', sortable: false }
]

// Visibilidad de stock especial (por defecto oculto para no interferir)
const showReceptionStock = ref(false)
const showQuarantineStock = ref(false)

const filters = ref({
  category: '',
  location_id: '',
  stockStatus: '',
  // Filtros por claves GS1 (checklist 4.3)
  gtin: '',
  lot_number: '',
  serial_number: '',
  sscc: '',
  expiry_from: '',
  expiry_to: ''
})

const adjustmentType = ref('add')
const adjustmentQuantity = ref(1)
const adjustmentReason = ref('Inventario Físico')
const adjustmentReasonOther = ref('')
const adjustmentNotes = ref('')

const newProduct = ref({
  sku: '',
  name: '',
  category: '',
  description: '',
  barcode: '',
  abc_category: '',
  warehouse_id: null,
  zone_id: null,
  location: '',
  current_stock: 0,
  min_stock: 0,
  max_stock: 0,
  weight: 0,
  length: 0,
  width: 0,
  height: 0,
  status: 'active'
})

const newInventory = ref({
  location_id: null,
  quantity: 0,
  lot_number: ''
})

// Definición de headers para v-data-table (Vuetify 3)
const headers = computed(() => {
  const baseHeaders = [
    { title: '',          key: 'expand',           align: 'center', sortable: false, width: '50px' },
    { title: 'Código',    key: 'product_sku',      align: 'start',  sortable: true },
    { title: 'Producto',  key: 'product_name',     align: 'start',  sortable: true },
    { title: 'Categoría', key: 'category',         align: 'start',  sortable: true },
    { title: 'Stock',     key: 'quantity',         align: 'end',    sortable: true },
    { title: 'Ubicación', key: 'location_code',    align: 'start',  sortable: true },
    { title: 'Estado',    key: 'stock_status_text', align: 'center', sortable: true }
  ]
  
  // Solo agregar columna "Acciones" si no es visualizador
  if (!isViewer.value) {
    baseHeaders.push({ title: 'Acciones',  key: 'actions', align: 'center', sortable: false })
  }
  
  return baseHeaders
})

// Referencias a store
const rawInventoryFromStore = computed(() => store.getters['inventory/allInventory'] || [])
const productsFromStore = computed(() => store.getters['products/allProducts'] || [])
const locations = computed(() => store.getters['locations/allLocations'] || [])
const warehouses = computed(() => store.getters['warehouses/allWarehouses'] || [])

// Computed
const isEditFormValid = computed(() => {
  if (!editForm.value) return false
  return editForm.value.validate()
})

const isNewProductValid = computed(() => {
  if (!newProductForm.value) return false
  return newProductForm.value.validate()
})

const isAdjustmentValid = computed(() => {
  return adjustmentQuantity.value > 0 && 
    (adjustmentReason.value !== 'Otro' || adjustmentReasonOther.value.trim() !== '')
})

const availableCategories = computed(() => {
  // Intentar usar las categorías del store primero
  const categoriesFromStore = store.getters['categories/allCategories'] || []
  
  if (categoriesFromStore.length > 0) {
    return categoriesFromStore.map(cat => ({
      title: cat.name,
      value: cat.name,
      id: cat.id
    }))
  }
  
  // Fallback: crear desde los productos si no hay categorías en el store
  const categories = new Set()
  productsFromStore.value.forEach(p => {
    if (p.category) categories.add(p.category)
  })
  return Array.from(categories).map(cat => ({
    title: cat,
    value: cat,
    id: null // No hay ID real para estas categorías
  }))
})

const locationsForSelect = computed(() => {
  return locations.value.map(location => ({
    title: `${location.code} - ${location.description || 'Sin descripción'}`,
    value: location.id
  }))
})

const hasActiveFilters = computed(() => {
  return !!(searchQuery.value?.trim() ||
           filters.value.category ||
           filters.value.location_id ||
           filters.value.stockStatus ||
           filters.value.gtin ||
           filters.value.lot_number ||
           filters.value.serial_number ||
           filters.value.sscc ||
           filters.value.expiry_from ||
           filters.value.expiry_to)
})

const noDataMessage = computed(() => {
  if (loading.value) return 'Cargando datos...'
  if (hasActiveFilters.value) return 'No se encontraron productos con los criterios de búsqueda'
  return 'No hay productos en el inventario'
})

// Computed properties para el dashboard
const totalProducts = computed(() => productsFromStore.value.length)

const totalStock = computed(() => flatInventory.value.reduce((sum, item) => sum + item.quantity, 0))

const totalCategories = computed(() => {
  const categories = new Set(productsFromStore.value.map(p => p.category))
  return categories.size
})

const criticalStock = computed(() => 
  flatInventory.value.filter(item => {
    const status = getStockStatus(item)
    return status === 'Crítico' || status === 'Bajo'
  }).length
)

// Función para determinar el estado del stock (debe estar antes de flatInventory)
const getStockStatus = (item) => {
  // Coerción numérica: la cantidad agrupada o min/max_stock pueden llegar como
  // string o null desde la API — el typeof estricto anterior tiraba
  // console.error en cada render (bug preexistente de marzo 2026)
  const quantity = Number(item.quantity)
  const minStock = Number(item.min_stock ?? 0)
  const maxStock = Number(item.max_stock ?? 0)

  if (!Number.isFinite(quantity)) {
    return 'Sin Datos'
  }

  // Si la cantidad es 0 o negativa, siempre es Agotado
  if (quantity <= 0) {
    return 'Agotado'
  }

  // Si min_stock es 0 (o no está definido), usamos una lógica diferente
  if (!Number.isFinite(minStock) || minStock === 0) {
    if (Number.isFinite(maxStock) && maxStock > 0 && quantity >= maxStock) {
      return 'Exceso'
    }
    return 'Normal'
  }

  // Lógica normal cuando min_stock > 0
  if (quantity <= minStock * 0.5) {
    return 'Crítico'
  } else if (quantity <= minStock) {
    return 'Bajo'
  } else if (Number.isFinite(maxStock) && maxStock > 0 && quantity >= maxStock) {
    return 'Exceso'
  }

  return 'Normal'
}

// Función para obtener el color del estado del stock
const getStockStatusColor = (item) => {
  const status = getStockStatus(item)
  const colors = {
    'Agotado': 'red-darken-2',
    'Crítico': 'red-darken-1', 
    'Bajo': 'orange-darken-1',
    'Normal': 'green',
    'Exceso': 'blue'
  }
  return colors[status] || 'grey'
}

// Computed para aplanar el inventario y mapear productos
const flatInventory = computed(() => {
  console.log('[DEBUG] rawInventoryFromStore:', rawInventoryFromStore.value)
  console.log('[DEBUG] productsFromStore:', productsFromStore.value)
  
  // Protección adicional: verificar que los datos básicos estén disponibles
  if (loading.value) {
    console.log('[DEBUG] flatInventory: Aún cargando datos, retornando array vacío')
    return []
  }
  
  if (!rawInventoryFromStore.value || rawInventoryFromStore.value.length === 0) {
    console.log('[DEBUG] flatInventory: rawInventoryFromStore está vacío o no definido')
    return []
  }
  
  if (!Array.isArray(rawInventoryFromStore.value)) {
    console.log('[DEBUG] flatInventory: rawInventoryFromStore no es un array válido')
    return []
  }

  // productsFromStore podría no estar listo la primera vez
  const productsMap = new Map()
  if (productsFromStore.value && Array.isArray(productsFromStore.value)) {
    productsFromStore.value.forEach(product => {
      if (product && product.id) {
        productsMap.set(product.id, product)
      }
    })
  }
  console.log('[DEBUG] productsMap size:', productsMap.size)

  const mappedItems = rawInventoryFromStore.value.map((item, index) => {
    // Protección: verificar que el item sea válido
    if (!item || typeof item !== 'object') {
      console.log('[DEBUG] Item inválido omitido:', item)
      return null
    }
    
    console.log('[DEBUG] Procesando item:', item)
    const productId = item.product_id || (item.product ? item.product.id : null)
    const productDetailsFromMap = productId ? productsMap.get(productId) : null
    
    const mappedItem = {
      ...item,
      product_id: productId,
      product_sku: item.product_sku || (item.product ? item.product.sku : 'SKU Desconocido'),
      product_name: item.product_name || (item.product ? item.product.name : 'Producto Desconocido'),
      category: item.category || (productDetailsFromMap ? productDetailsFromMap.category : 'Sin Categoría'),
      location_id: item.location_id || (item.location ? item.location.id : null),
      location_code: item.location_code || (item.location ? item.location.code : 'N/A'),
      lot_number: item.lot_number || (item.lot_number ? item.lot_number : 'N/A'),
      quantity: typeof item.quantity === 'number' ? item.quantity : 0,
      min_stock: typeof item.min_stock === 'number' ? item.min_stock : (productDetailsFromMap ? productDetailsFromMap.min_stock || 0 : 0),
      max_stock: typeof item.max_stock === 'number' ? item.max_stock : (productDetailsFromMap ? productDetailsFromMap.max_stock || 0 : 0),
      status_product: item.status || (productDetailsFromMap ? productDetailsFromMap.status : 'active'),
      stock_status_text: getStockStatus({
        quantity: typeof item.quantity === 'number' ? item.quantity : 0,
        min_stock: typeof item.min_stock === 'number' ? item.min_stock : (productDetailsFromMap ? productDetailsFromMap.min_stock || 0 : 0),
        max_stock: typeof item.max_stock === 'number' ? item.max_stock : (productDetailsFromMap ? productDetailsFromMap.max_stock || 0 : 0)
      })
    }
    
    console.log('[DEBUG] Item mapeado:', mappedItem)
    return mappedItem
  })

  // Filtrar items null/inválidos
  const validItems = mappedItems.filter(item => item !== null)
  
  console.log('[DEBUG] Total items mapeados:', validItems.length)
  return validItems
})

// Computed para filtrado
const filteredInventory = computed(() => {
  console.log('[DEBUG] Filtrando inventory, items iniciales:', flatInventory.value.length)
  let result = flatInventory.value
  
  // Filtro por estado de producto (activo/inactivo)
  if (!showInactiveProducts.value) {
    result = result.filter(item => {
      const productStatus = getProductStatus(item.product_id)
      return productStatus === 'active'
    })
    console.log('[DEBUG] Items después de filtro activos:', result.length)
  }
  
  // Filtro de búsqueda por texto
  if (searchQuery.value && searchQuery.value.trim()) {
    const query = searchQuery.value.toLowerCase().trim()
    result = result.filter(item => 
      item.product_sku?.toLowerCase().includes(query) ||
      item.product_name?.toLowerCase().includes(query) ||
      item.category?.toLowerCase().includes(query) ||
      item.location_code?.toLowerCase().includes(query)
    )
    console.log('[DEBUG] Items después de búsqueda:', result.length)
  }
  
  // Filtro por categoría
  if (filters.value.category) {
    result = result.filter(item => item.category === filters.value.category)
    console.log('[DEBUG] Items después de filtro categoría:', result.length)
  }
  
  // Filtro por ubicación
  if (filters.value.location_id) {
    result = result.filter(item => item.location_id === filters.value.location_id)
    console.log('[DEBUG] Items después de filtro ubicación:', result.length)
  }
  
  // Filtro por estado de stock
  if (filters.value.stockStatus) {
    result = result.filter(item => {
      const status = getStockStatus(item)
      // Mapear los valores del filtro a los valores reales de getStockStatus
      const statusMap = {
        'normal': 'Normal',
        'low': 'Bajo', 
        'critical': 'Crítico',
        'excess': 'Exceso'
      }
      return status === statusMap[filters.value.stockStatus]
    })
    console.log('[DEBUG] Items después de filtro estado:', result.length)
  }
  
  // ---- Stock especial: Zona de Recepción y cuarentena ocultos por defecto ----
  if (!showReceptionStock.value) {
    result = result.filter(item => item.location_code !== 'RECEPCION')
  }
  if (!showQuarantineStock.value) {
    result = result.filter(item => !item.is_quarantined)
  }

  // ---- Filtros por claves GS1 (checklist 4.3) ----
  if (filters.value.gtin) {
    const q = String(filters.value.gtin).replace(/\D/g, '')
    result = result.filter(item => {
      const codes = [item.gtin, item.barcode].filter(Boolean)
      return codes.some(c => {
        const d = String(c).replace(/\D/g, '')
        return d && (d.padStart(14, '0') === q.padStart(14, '0') || d.includes(q))
      })
    })
  }
  if (filters.value.lot_number) {
    const q = filters.value.lot_number.toLowerCase()
    result = result.filter(item => item.lot_number && item.lot_number !== 'N/A' && item.lot_number.toLowerCase().includes(q))
  }
  if (filters.value.serial_number) {
    const q = filters.value.serial_number.toLowerCase()
    result = result.filter(item => item.serial_number && item.serial_number.toLowerCase().includes(q))
  }
  if (filters.value.sscc) {
    const q = String(filters.value.sscc).replace(/\D/g, '')
    result = result.filter(item => item.sscc && String(item.sscc).includes(q))
  }
  if (filters.value.expiry_from) {
    result = result.filter(item => item.expiry_date && item.expiry_date >= filters.value.expiry_from)
  }
  if (filters.value.expiry_to) {
    result = result.filter(item => item.expiry_date && item.expiry_date <= filters.value.expiry_to)
  }

  console.log('[DEBUG] Items finales después de todos los filtros:', result.length)
  return result
})

// Computed para agrupar productos por SKU/product_id
const groupedInventory = computed(() => {
  const filtered = filteredInventory.value
  const grouped = new Map()
  
  // Agrupar por product_id
  filtered.forEach(item => {
    const productId = item.product_id
    if (!grouped.has(productId)) {
      grouped.set(productId, {
        // Datos principales del grupo (usando el primer item)
        id: `group_${productId}`,
        product_id: productId,
        product_sku: item.product_sku,
        product_name: item.product_name,
        category: item.category,
        location_code: item.location_code, // Se mostrará la primera ubicación
        stock_status_text: item.stock_status_text,
        // Trazabilidad DM (chips en la fila agrupada)
        es_dispositivo_medico: !!item.es_dispositivo_medico,
        es_dm_priorizado: !!item.es_dm_priorizado,
        tipo_dm: item.tipo_dm || null,
        // Datos agregados
        quantity: 0,
        isGroup: true,
        lots: [], // Array de lotes individuales
        totalLots: 0
      })
    }
    
    const group = grouped.get(productId)
    group.quantity += item.quantity
    group.totalLots += 1
    group.lots.push(item) // Agregar el item completo como detalle de lote
  })
  
  // Convertir Map a Array y crear la estructura final
  const result = []
  
  grouped.forEach(group => {
    // Si solo hay un lote, mostrarlo como item individual, no como grupo
    if (group.totalLots === 1) {
      const singleItem = group.lots[0]
      result.push({
        ...singleItem,
        // No marcarlo como grupo ni como detalle - es un item individual
        isGroup: false,
        isLotDetail: false
      })
    } else {
      // Agregar la fila del grupo principal (múltiples lotes)
      result.push(group)
      
      // Si el producto está expandido, agregar los detalles de lotes
      if (expandedProducts.value.has(group.product_id)) {
        group.lots.forEach(lot => {
          result.push({
            ...lot,
            isLotDetail: true,
            parentProductId: group.product_id
          })
        })
      }
    }
  })
  
  console.log('[DEBUG] Productos agrupados:', result.length, 'grupos:', grouped.size)
  return result
})

// Métodos para expandir/colapsar productos
const toggleProductExpansion = (productId) => {
  const expanded = expandedProducts.value
  if (expanded.has(productId)) {
    expanded.delete(productId)
  } else {
    expanded.add(productId)
  }
  // Forzar reactivity
  expandedProducts.value = new Set(expanded)
}

const isProductExpanded = (productId) => {
  return expandedProducts.value.has(productId)
}

// Métodos
const viewInventoryItem = (item) => {
  selectedItem.value = item
  showDetailDialog.value = true
}

const editInventoryItem = (item) => {
  const product = productsFromStore.value.find(p => p.id === item.product_id)
  if (!product) {
    toast.error('No se puede editar: producto no encontrado')
    return
  }
  
  // Preparar los datos del producto para edición, manejando la estructura anidada
  editingProduct.value = {
    ...product,
    // Extraer dimensiones de la estructura anidada si existe
    length: product.dimensions ? product.dimensions.length || 0 : (product.length || 0),
    width: product.dimensions ? product.dimensions.width || 0 : (product.width || 0),
    height: product.dimensions ? product.dimensions.height || 0 : (product.height || 0),
    // Asegurar que weight existe
    weight: product.weight || 0
  }
  
  console.log('Datos del producto para edición:', editingProduct.value) // Debug temporal
  showEditDialog.value = true
}

const showAdjustModal = (item) => {
  selectedItem.value = item
  adjustmentType.value = 'add'
  adjustmentQuantity.value = 1
  adjustmentReason.value = 'Inventario Físico'
  adjustmentReasonOther.value = ''
  adjustmentNotes.value = ''
  showAdjustDialog.value = true
}

const showNewItemModal = () => {
  newProduct.value = {
    sku: '',
    name: '',
    category: '',
    description: '',
    barcode: '',
    abc_category: '',
    warehouse_id: null,
    zone_id: null,
    location: '',
    current_stock: 0,
    min_stock: 0,
    max_stock: 0,
    weight: 0,
    length: 0,
    width: 0,
    height: 0,
    status: 'active'
  }
  newInventory.value = {
    location_id: null,
    quantity: 0,
    lot_number: ''
  }
  showNewProductDialog.value = true
}

const saveProduct = async () => {
  if (!isEditFormValid.value) return
  
  try {
    await store.dispatch('products/updateProduct', editingProduct.value)
    showEditDialog.value = false
    toast.success('Producto actualizado exitosamente')
    
    // Si vino del modal de gestión, regresar a él
    if (fromManageModal.value) {
      fromManageModal.value = false
      showManageProducts.value = true
    }
  } catch (err) {
    console.error('Error al actualizar producto:', err)
    toast.error('Error al actualizar producto: ' + (err.message || 'Error desconocido'))
  }
}

const applyAdjustment = async () => {
  if (!selectedItem.value || !isAdjustmentValid.value) return
  
  let newQuantity = selectedItem.value.quantity
  
  if (adjustmentType.value === 'add') {
    newQuantity += adjustmentQuantity.value
  } else if (adjustmentType.value === 'subtract') {
    newQuantity -= adjustmentQuantity.value
  } else if (adjustmentType.value === 'set') {
    newQuantity = adjustmentQuantity.value
  }
  
  const reason = adjustmentReason.value === 'Otro' ? adjustmentReasonOther.value : adjustmentReason.value
      
      const adjustment = {
    id: selectedItem.value.id,
        quantity: newQuantity,
        reason: reason,
    notes: adjustmentNotes.value
  }
  
  try {
    await store.dispatch('inventory/adjustInventory', adjustment)
    showAdjustDialog.value = false
    await store.dispatch('inventory/fetchInventory')
    toast.success('Inventario ajustado exitosamente')
  } catch (err) {
          console.error('Error al ajustar inventario:', err)
    toast.error('Error al ajustar inventario: ' + (err.message || 'Error desconocido'))
  }
}

const saveNewProduct = async (productData) => {
  try {
    const newProductData = await store.dispatch('products/createProduct', productData)
    showNewProductDialog.value = false
    await Promise.all([
      store.dispatch('products/fetchProducts'),
      store.dispatch('inventory/fetchInventory')
    ])
    toast.success('Producto creado exitosamente')
    
    // Si vino del modal de gestión, regresar a él
    if (fromManageModal.value) {
      fromManageModal.value = false
      showManageProducts.value = true
    }
  } catch (err) {
    console.error('Error al crear producto:', err)
    toast.error('Error al crear producto: ' + (err.message || 'Error desconocido'))
  }
}

const resetFilters = () => {
  filters.value = {
        category: '',
        location_id: '',
        stockStatus: ''
      }
  searchQuery.value = ''
}

const applyFilters = () => {
  // Los filtros se aplican automáticamente a través del computed property
}

// Funciones de utilidad
const formatDate = (dateString) => {
      if (!dateString) return 'N/A'
      const date = new Date(dateString)
      return date.toLocaleDateString('es-ES', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      })
}

const getProductName = (productId) => {
  const item = flatInventory.value.find(i => i.product_id === productId)
  return item ? item.product_name : `Producto #${productId}`
}

const getProductSku = (productId) => {
  const item = flatInventory.value.find(i => i.product_id === productId)
  return item ? item.product_sku : `SKU-${productId}`
}

const getProductCategory = (productId) => {
  const item = flatInventory.value.find(i => i.product_id === productId)
  return item ? item.category : 'Sin categoría'
}

const getProductDescription = (productId) => {
  const item = flatInventory.value.find(i => i.product_id === productId)
  return item ? item.description : 'Sin descripción'
}

const getProductUnitOfMeasure = (productId) => {
  const item = flatInventory.value.find(i => i.product_id === productId)
  return item ? item.unit_of_measure : 'unidad'
}

const getProductMinStock = (productId) => {
  const item = flatInventory.value.find(i => i.product_id === productId)
  return item ? item.min_stock : 0
}

const getProductMaxStock = (productId) => {
  const item = flatInventory.value.find(i => i.product_id === productId)
  return item ? item.max_stock : 0
}

const getProductWeight = (productId) => {
  if (!productId) {
    console.log('ProductId no proporcionado para peso')
    return 0
  }
  
  const product = productsFromStore.value.find(p => p.id === productId)
  console.log(`Producto encontrado para peso (ID: ${productId}):`, product) // Debug temporal
  
  if (!product) {
    console.log(`No se encontró producto con ID: ${productId}`)
    return 0
  }
  
  const weight = product.weight ? product.weight : 0
  console.log('Peso obtenido:', weight) // Debug temporal
  return weight
}

const getProductDimensions = (productId) => {
  if (!productId) {
    console.log('ProductId no proporcionado para dimensiones')
    return 'No especificado'
  }
  
  const product = productsFromStore.value.find(p => p.id === productId)
  console.log(`Producto encontrado para dimensiones (ID: ${productId}):`, product) // Debug temporal
  
  if (!product) {
    console.log(`No se encontró producto con ID: ${productId}`)
    return 'No especificado'
  }
  
  // Verificar si las dimensiones están en la estructura anidada (como viene del backend)
  let length, width, height
  
  if (product.dimensions) {
    length = product.dimensions.length || 0
    width = product.dimensions.width || 0
    height = product.dimensions.height || 0
    console.log('Usando estructura anidada:', { length, width, height }) // Debug temporal
  } else {
    // Fallback para estructura plana
    length = product.length || 0
    width = product.width || 0
    height = product.height || 0
    console.log('Usando estructura plana:', { length, width, height }) // Debug temporal
  }
  
  if (length === 0 && width === 0 && height === 0) {
    return 'No especificado'
  }
  
  return `${length} x ${width} x ${height} cm`
}

const getLocationName = (locationId) => {
  const location = locations.value.find(l => l.id === locationId)
      return location ? `${location.code} - ${location.description || 'Sin descripción'}` : `Ubicación #${locationId}`
}

const getWarehouseName = (locationId) => {
  const location = locations.value.find(l => l.id === locationId)
      if (!location || !location.warehouse_id) return 'Sin bodega'
      
  const warehouse = warehouses.value.find(w => w.id === location.warehouse_id)
      return warehouse ? warehouse.name : `Bodega #${location.warehouse_id}`
}

// Método de búsqueda con debounce
const debouncedSearch = debounce((value) => {
  searchQuery.value = value
}, 300)

// Método de exportación
const exportInventory = async () => {
  try {
    exporting.value = true
    // Reporte con claves GS1 como identificación (checklist 4.1/4.3):
    // respeta los filtros activos (GTIN, lote, serie, SSCC, vencimiento)
    const data = filteredInventory.value.map(item => ({
      'GTIN': item.gtin || item.barcode || item.product_sku,
      'Producto': item.product_name,
      'Categoría': item.category,
      'Stock': item.quantity,
      'Lote (10)': (item.lot_number && item.lot_number !== 'N/A') ? item.lot_number : '',
      'Vencimiento (17)': item.expiry_date ? String(item.expiry_date).slice(0, 10) : '',
      'N° Serie (21)': item.serial_number || '',
      'SSCC (00)': item.sscc || '',
      'Ubicación': item.location_code,
      'Estado': getStockStatus(item),
      'Última Actualización': formatDate(item.updated_at)
    }))

    // Crear el archivo CSV (valores escapados para comas/comillas en nombres)
    const esc = v => `"${String(v ?? '').replace(/"/g, '""')}"`
    const csvContent = [
      Object.keys(data[0]).map(esc).join(','),
      ...data.map(row => Object.values(row).map(esc).join(','))
    ].join('\n')

    // Descargar el archivo — BOM UTF-8 para que Excel/Sheets muestre bien las tildes
    const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' })
    const link = document.createElement('a')
    const url = URL.createObjectURL(blob)
    link.setAttribute('href', url)
    link.setAttribute('download', `inventario_${new Date().toISOString().split('T')[0]}.csv`)
    link.style.visibility = 'hidden'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    
    toast.success('Inventario exportado exitosamente')
  } catch (error) {
    console.error('Error al exportar inventario:', error)
    toast.error('Error al exportar inventario')
  } finally {
    exporting.value = false
  }
}

// Watch para depuración del store
watch(rawInventoryFromStore, (newVal) => {
  console.log('[DEBUG] rawInventoryFromStore updated:', {
    type: typeof newVal,
    isArray: Array.isArray(newVal),
    length: newVal?.length,
    value: newVal
  })
}, { immediate: true, deep: true })

// Watch para resetear página cuando cambie la búsqueda
watch(searchQuery, () => {
  currentPage.value = 1
})

// Función para iniciar el interval de actualización automática
const startInventoryUpdateInterval = () => {
  // Limpiar interval existente si hay uno
  if (inventoryUpdateInterval.value) {
    clearInterval(inventoryUpdateInterval.value)
  }
  
  // Crear nuevo interval que actualiza cada 5 segundos
  inventoryUpdateInterval.value = setInterval(async () => {
    try {
      // Actualizar inventario silenciosamente (sin mostrar loading)
      await store.dispatch('inventory/fetchInventory')
    } catch (error) {
      console.error('Error en actualización automática del inventario:', error)
      // No mostrar toast para errores de actualización automática para no molestar al usuario
    }
  }, 5000) // 5 segundos
}

// Función para limpiar el interval
const clearInventoryUpdateInterval = () => {
  if (inventoryUpdateInterval.value) {
    clearInterval(inventoryUpdateInterval.value)
    inventoryUpdateInterval.value = null
  }
}

// ========== NUEVOS MÉTODOS PARA GESTIÓN DE PRODUCTOS Y CATEGORÍAS ==========

// Función para obtener el estado de un producto
const getProductStatus = (productId) => {
  const product = productsFromStore.value.find(p => p.id === productId)
  return product ? product.status : 'active'
}

// Función para obtener el conteo de productos por categoría
const getProductCountByCategory = (categoryName) => {
  // Contar solo productos que tienen inventario activo y que se mostrarían en la tabla
  // Aplicar la misma lógica de filtrado que la tabla principal
  let filteredItems = flatInventory.value.filter(item => 
    item.category === categoryName && item.quantity > 0
  )
  
  // Si no se muestran productos inactivos, filtrar solo los activos
  if (!showInactiveProducts.value) {
    filteredItems = filteredItems.filter(item => {
      const productStatus = getProductStatus(item.product_id)
      return productStatus === 'active'
    })
  }
  
  return filteredItems.length
}

// Funciones de gestión de productos
const showDeleteConfirmation = (item) => {
  itemToDelete.value = item
  showDeleteDialog.value = true
}

const confirmDelete = async () => {
  if (!itemToDelete.value) return
  
  try {
    deleting.value = true
    const productId = itemToDelete.value.product_id || itemToDelete.value.id
    
    // Eliminar el producto (esto también debería eliminar su inventario)
    await store.dispatch('products/deleteProduct', productId)
    
    // Recargar datos
    await Promise.all([
      store.dispatch('products/fetchProducts'),
      store.dispatch('inventory/fetchInventory')
    ])
    
    showDeleteDialog.value = false
    itemToDelete.value = null
    toast.success('Producto eliminado exitosamente')
    
    // Si vino del modal de gestión, regresar a él
    if (fromManageModal.value) {
      fromManageModal.value = false
      showManageProducts.value = true
    }
  } catch (error) {
    console.error('Error al eliminar producto:', error)
    toast.error('Error al eliminar producto: ' + (error.message || 'Error desconocido'))
  } finally {
    deleting.value = false
  }
}

// Abrir edición desde modal gestionar
const openEditProduct = (product) => {
  // product puede venir de tabla de productos (estructura plana)
  fromManageModal.value = true
  editingProduct.value = { ...product }
  showEditDialog.value = true
}

// Abrir confirmación eliminar desde modal gestionar
const openDeleteProduct = (product) => {
  fromManageModal.value = true
  itemToDelete.value = { product_id: product.id, product_name: product.name }
  showDeleteDialog.value = true
}

// Crear producto desde modal de gestión
const createProductFromManagement = () => {
  fromManageModal.value = true
  showNewItemModal()
}

// ========== MÉTODOS DE CARGA MASIVA EXCEL ==========

// Cerrar modal de carga masiva
const closeBulkUpload = () => {
  if (processing.value) return // No permitir cerrar si está procesando
  
  showBulkUpload.value = false
  uploadStep.value = '1'
  uploadedFile.value = null
  excelData.value = []
  processedProducts.value = []
  uploading.value = false
  processing.value = false
}

// Generar código EAN-13 único para frontend (temporal para preview)
const generateTempEAN13 = () => {
  const prefix = '789'
  const companyCode = '00'
  
  // Generar secuencia de 7 dígitos random
  const sequence = Math.floor(Math.random() * 10000000).toString().padStart(7, '0')
  
  // Formar los primeros 12 dígitos
  const ean12 = `${prefix}${companyCode}${sequence}`
  
  // Calcular dígito verificador
  let oddSum = 0
  let evenSum = 0
  
  for (let i = 0; i < 12; i++) {
    if (i % 2 === 0) {
      oddSum += parseInt(ean12[i])
    } else {
      evenSum += parseInt(ean12[i])
    }
  }
  
  const total = oddSum + (evenSum * 3)
  const checkDigit = (10 - (total % 10)) % 10
  
  return ean12 + checkDigit.toString()
}

// Detectar tipo de código de barras y extraer GTIN si es GS1
const analyzeBarcode = (barcode) => {
  if (!barcode || barcode.trim() === '') {
    // Generar EAN-13 automáticamente para productos sin código
    const generatedEAN13 = generateTempEAN13()
    console.log('🏷️ Código EAN-13 generado automáticamente:', generatedEAN13)
    return { 
      type: 'T-logis', 
      gtin: generatedEAN13, 
      original: '', 
      generated: true,
      autoGenerated: true 
    }
  }
  
  const cleaned = barcode.trim()
  
  // DETECCIÓN GS1 SIMPLIFICADA Y AGRESIVA
  // Si empieza con 01 y tiene más de 16 caracteres, es GS1
  // Si contiene paréntesis, es GS1
  // Si es muy largo (más de 16 chars) y empieza con dígito, probablemente GS1
  const isGS1 = cleaned.includes('(') || 
                (cleaned.startsWith('01') && cleaned.length > 16) ||
                isAI01Only(cleaned) ||
                (cleaned.length > 20 && /^\d/.test(cleaned))
  
  // Debug logging
  if (cleaned.length > 15 || cleaned.startsWith('01')) {
    console.log('🧪 Analizando código:', {
      original: cleaned,
      length: cleaned.length,
      startsWithParens: cleaned.includes('('),
      startsWithAI01: cleaned.startsWith('01') && cleaned.length > 16,
      isVeryLong: cleaned.length > 20 && /^\d/.test(cleaned),
      finalDecision: isGS1 ? 'GS1' : 'NO-GS1'
    })
  }
  
  if (isGS1) {
    const gtin = extractGTIN(cleaned)
    const result = { 
      type: 'GS1', 
      gtin: gtin,
      original: cleaned,
      hasVariableData: gtin !== cleaned
    }
    
    console.log('✅ Identificado como GS1:', result)
    return result
  }
  
  // Solo evaluar códigos de longitud fija si NO es GS1
  // EAN-13 (exactamente 13 dígitos)
  if (/^\d{13}$/.test(cleaned)) {
    console.log('📊 Identificado como EAN-13:', cleaned)
    return { type: 'EAN-13', gtin: cleaned, original: cleaned }
  }
  
  // UPC-A (exactamente 12 dígitos)
  if (/^\d{12}$/.test(cleaned)) {
    console.log('📊 Identificado como UPC-A:', cleaned)
    return { type: 'UPC-A', gtin: cleaned, original: cleaned }
  }
  
  // EAN-8 (exactamente 8 dígitos)
  if (/^\d{8}$/.test(cleaned)) {
    console.log('📊 Identificado como EAN-8:', cleaned)
    return { type: 'EAN-8', gtin: cleaned, original: cleaned }
  }
  
  // Códigos de longitud intermedia que podrían ser variantes
  if (/^\d{10,11}$/.test(cleaned)) {
    console.log('📊 Identificado como UPC variante:', cleaned)
    return { type: 'UPC', gtin: cleaned, original: cleaned }
  }
  
  // Códigos que empiecen con 01 pero no se detectaron como GS1 (fallback)
  if (cleaned.startsWith('01') && cleaned.length >= 14) {
    console.log('🔄 Fallback GS1 para código con 01:', cleaned)
    const gtin = extractGTIN(cleaned)
    return { 
      type: 'GS1', 
      gtin: gtin, 
      original: cleaned,
      hasVariableData: gtin !== cleaned 
    }
  }
  
  // Otro formato
  console.log('❓ Clasificado como Otro:', cleaned)
  return { type: 'Otro', gtin: cleaned, original: cleaned }
}

// Extraer GTIN de código GS1
const extractGTIN = (gs1Code) => {
  if (!gs1Code) return null
  
  // Remover paréntesis si existen
  let cleaned = gs1Code.replace(/[()]/g, '')
  
  console.log('🔧 Extrayendo GTIN de:', cleaned, 'Longitud:', cleaned.length)
  
  // Si empieza con AI 01 (GTIN)
  if (cleaned.startsWith('01')) {
    // Método 1: Buscar AI 01 seguido de exactamente 14 dígitos
    const gtinMatch = cleaned.match(/^01(\d{14})/)
    if (gtinMatch) {
      const gtin = gtinMatch[1]
      console.log('✅ GTIN extraído (método 1):', gtin)
      return gtin
    }
    
    // Método 2: Tomar los caracteres 2-15 (14 caracteres) después de '01'
    if (cleaned.length >= 16) {
      const potentialGTIN = cleaned.substring(2, 16) // Posiciones 2-15 (14 caracteres)
      
      // Verificar si son todos dígitos
      if (/^\d{14}$/.test(potentialGTIN)) {
        console.log('✅ GTIN extraído (método 2):', potentialGTIN)
        return potentialGTIN
      }
      
      // Si no son todos dígitos, intentar extraer solo los dígitos
      const digitsOnly = potentialGTIN.replace(/\D/g, '')
      if (digitsOnly.length >= 12) { // Al menos 12 dígitos para considerar válido
        const paddedGTIN = digitsOnly.padEnd(14, '0').substring(0, 14)
        console.log('⚠️ GTIN extraído con padding (método 2b):', paddedGTIN)
        return paddedGTIN
      }
    }
    
    // Método 3: Para códigos con AIs secuenciales (como 21), buscar donde termina el GTIN
    // Ejemplo: 01049429622204842JJM23130075_ 
    // Buscar patrón: 01 + dígitos + (AI conocido como 10,11,17,21) o letras
    const complexMatch = cleaned.match(/^01(\d+?)(?:[A-Z]|10|11|17|21|30)/)
    if (complexMatch) {
      let gtinCandidate = complexMatch[1]
      
      // Si tiene más de 14 dígitos, tomar solo los primeros 14
      if (gtinCandidate.length >= 14) {
        gtinCandidate = gtinCandidate.substring(0, 14)
      } else {
        // Si tiene menos de 14, completar con ceros
        gtinCandidate = gtinCandidate.padEnd(14, '0')
      }
      
      console.log('✅ GTIN extraído (método 3):', gtinCandidate)
      return gtinCandidate
    }
    
    // Método 4: Fallback - extraer todos los dígitos después de '01'
    const afterAI = cleaned.substring(2)
    const allDigits = afterAI.match(/^(\d+)/)
    if (allDigits && allDigits[1].length >= 12) {
      const gtinFallback = allDigits[1].substring(0, 14).padEnd(14, '0')
      console.log('🔄 GTIN extraído (fallback):', gtinFallback)
      return gtinFallback
    }
  }
  
  // Si no empieza con 01, pero es un código largo numérico
  if (/^\d+$/.test(cleaned) && cleaned.length >= 14) {
    const numericGTIN = cleaned.substring(0, 14)
    console.log('📊 GTIN extraído (código numérico):', numericGTIN)
    return numericGTIN
  }
  
  // Para códigos muy largos, buscar cualquier patrón de 14 dígitos consecutivos
  if (cleaned.length > 20) {
    const longGtinMatch = cleaned.match(/(\d{14})/)
    if (longGtinMatch) {
      console.log('🔍 GTIN encontrado en código largo:', longGtinMatch[1])
      return longGtinMatch[1]
    }
  }
  
  console.log('❌ No se pudo extraer GTIN válido de:', gs1Code)
  
  // Si no se puede extraer GTIN, retornar el código original
  return cleaned
}

    // Procesar archivo Excel
    const processExcelFile = async (files) => {
      console.log('processExcelFile called with:', files)
      
      // files puede ser null, undefined, un array o un solo archivo
      let file = null
      
      if (files) {
        if (Array.isArray(files) && files.length > 0) {
          file = files[0]
        } else if (files && typeof files === 'object' && files.name) {
          // Es un archivo individual
          file = files
        }
      }
      
      if (!file || !file.name) {
        console.log('No se encontró archivo válido')
        return // No mostrar error si no hay archivo (puede ser que lo hayan removido)
      }
      
      try {
        uploading.value = true
        
        console.log('Procesando archivo:', file.name, 'Tamaño:', file.size, 'Tipo:', file.type)
        
        // Validar que sea un archivo Excel
        const validTypes = [
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
          'application/vnd.ms-excel', // .xls
          'application/excel'
        ]
        
        if (!validTypes.some(type => file.type.includes(type)) && 
            !file.name.toLowerCase().endsWith('.xlsx') && 
            !file.name.toLowerCase().endsWith('.xls')) {
          toast.error('Por favor seleccione un archivo Excel válido (.xlsx o .xls)')
          return
        }
        
        // Importar SheetJS dinámicamente
        const XLSX = await import('xlsx')
        
        const data = await file.arrayBuffer()
        const workbook = XLSX.read(data, { type: 'array' })
    
    // Tomar la primera hoja
    const sheetName = workbook.SheetNames[0]
    const worksheet = workbook.Sheets[sheetName]
    
    // Convertir a JSON
    const jsonData = XLSX.utils.sheet_to_json(worksheet, { 
      header: 1,
      defval: '' // Valores vacíos como string vacío
    })
    
    if (jsonData.length < 2) {
      toast.error('El archivo debe tener al menos 2 filas (encabezados + datos)')
      return
    }
    
    // Validar headers
    const headers = jsonData[0].map(h => h.toString().toUpperCase().trim())
    const requiredHeaders = ['SKU', 'NOMBRE', 'CODIGO DE BARRAS']
    const missingHeaders = requiredHeaders.filter(h => !headers.includes(h))
    
    if (missingHeaders.length > 0) {
      toast.error(`Faltan columnas requeridas: ${missingHeaders.join(', ')}`)
      return
    }
    
    // Encontrar índices de columnas
    const skuIndex = headers.indexOf('SKU')
    const nameIndex = headers.indexOf('NOMBRE') 
    const barcodeIndex = headers.indexOf('CODIGO DE BARRAS')
    
    // Procesar datos (saltar header)
    const rawData = jsonData.slice(1)
      .filter(row => row[skuIndex] && row[skuIndex].toString().trim() !== '') // Filtrar filas sin SKU
      .map(row => ({
        sku: row[skuIndex]?.toString().trim() || '',
        name: row[nameIndex]?.toString().trim() || '',
        barcode: row[barcodeIndex]?.toString().trim() || ''
      }))
    
    excelData.value = rawData
    
    // Deduplicar por SKU y procesar códigos de barras
    const productMap = new Map()
    
    // Primero, agrupar todos los registros por SKU para poder buscar el mejor código de barras
    const skuGroups = new Map()
    
    for (const item of rawData) {
      if (!item.sku) continue
      
      if (!skuGroups.has(item.sku)) {
        skuGroups.set(item.sku, [])
      }
      skuGroups.get(item.sku).push(item)
    }
    
    // Ahora procesar cada grupo de SKU para encontrar el mejor código de barras
    for (const [sku, items] of skuGroups) {
      // Tomar el primer item para información básica (nombre, etc.)
      const firstItem = items[0]
      
      // Buscar el primer código de barras válido (no vacío) en todos los registros de este SKU
      let bestBarcode = ''
      let barcodeSource = null
      
      for (const item of items) {
        if (item.barcode && item.barcode.trim() !== '') {
          bestBarcode = item.barcode.trim()
          barcodeSource = item
          break // Tomar el primer código válido encontrado
        }
      }
      
      console.log(`📦 Procesando SKU ${sku}:`, {
        total_records: items.length,
        found_barcode: !!bestBarcode,
        barcode_value: bestBarcode || 'vacío',
        from_record: barcodeSource ? items.indexOf(barcodeSource) + 1 : 'ninguno'
      })
      
      // Analizar el código de barras (solo si existe, sino se genera automático)
      const barcodeAnalysis = analyzeBarcode(bestBarcode)
      
      // Debug logging para códigos sospechosos
      if (bestBarcode && (bestBarcode.includes('01') || bestBarcode.length > 15)) {
        console.log('🔍 Analizando código sospechoso:', {
          sku: sku,
          barcode_original: bestBarcode,
          barcode_length: bestBarcode.length,
          analysis: barcodeAnalysis
        })
      }
      
      productMap.set(sku, {
        sku: sku,
        name: firstItem.name,
        barcode: barcodeAnalysis.gtin || barcodeAnalysis.original || '', // Usar GTIN generado/extraído o código original
        barcode_original: bestBarcode, // Mantener original para referencia (vacío si no había ninguno)
        barcode_type: barcodeAnalysis.type,
        barcodeAnalysis: barcodeAnalysis,
        category: 'Importado', // Categoría por defecto
        status: 'active',
        min_stock: 0,
        max_stock: 1000,
        auto_generated_barcode: barcodeAnalysis.autoGenerated || false, // Marcar si fue generado automáticamente
        records_count: items.length // Para debug: cuántos registros tenía este SKU
      })
    }
    
    processedProducts.value = Array.from(productMap.values())
    uploadStep.value = '2'
    
    console.log('Productos procesados:', processedProducts.value)
    
  } catch (error) {
    console.error('Error procesando Excel:', error)
    toast.error('Error al procesar archivo Excel: ' + error.message)
  } finally {
    uploading.value = false
  }
}

// Obtener color para tipo de código de barras
const getBarcodeTypeColor = (type) => {
  switch (type) {
    case 'EAN-13':
    case 'UPC-A': return 'success'
    case 'GS1': return 'primary'
    case 'T-logis': return 'teal' // Color especial para códigos generados por Trazalogis
    case 'Sin código': return 'warning'
    default: return 'info'
  }
}

// Crear productos masivamente
const createBulkProducts = async () => {
  if (processedProducts.value.length === 0) return
  
  try {
    processing.value = true
    
    // Preparar datos para el backend
    const productsToCreate = processedProducts.value.map(product => ({
      sku: product.sku,
      name: product.name,
      barcode: product.barcode, // Este puede ser el código generado automáticamente
      category: product.category,
      status: product.status,
      min_stock: product.min_stock,
      max_stock: product.max_stock,
      // Metadatos adicionales para logging
      bulk_import: true,
      barcode_type: product.barcode_type,
      barcode_original: product.barcode_original || '', // Original del Excel (puede estar vacío)
      auto_generated: product.auto_generated_barcode // Indicar al backend si fue generado
    }))
    
    // Llamar al endpoint de creación masiva
    const response = await store.dispatch('products/createBulkProducts', productsToCreate)
    
    uploadStep.value = '3'
    
    // Recargar productos
    await store.dispatch('products/fetchProducts')
    
    setTimeout(() => {
      closeBulkUpload()
      showManageProducts.value = true // Volver al modal de gestión
      toast.success(`${processedProducts.value.length} productos creados exitosamente`)
    }, 2000)
    
  } catch (error) {
    console.error('Error creando productos masivamente:', error)
    toast.error('Error al crear productos: ' + (error.message || 'Error desconocido'))
  } finally {
    processing.value = false
  }
}

// Funciones de gestión de categorías
const createNewCategory = async () => {
  if (!newCategoryName.value.trim()) return
  
  try {
    creatingCategory.value = true
    
    await store.dispatch('categories/createCategory', {
      name: newCategoryName.value.trim()
    })
    
    // Recargar categorías después de la creación
    await store.dispatch('categories/fetchCategories')
    
    newCategoryName.value = ''
    toast.success('Categoría creada exitosamente')
  } catch (error) {
    console.error('Error al crear categoría:', error)
    toast.error('Error al crear categoría: ' + (error.message || 'Error desconocido'))
  } finally {
    creatingCategory.value = false
  }
}

const editCategory = (category) => {
  // Solo permitir editar categorías que tienen ID real del store
  if (!category.id) {
    toast.error('Esta categoría no se puede editar porque no está registrada en el sistema')
    return
  }
  
  editingCategory.value = category
  editingCategoryName.value = category.title
  showEditCategoryDialog.value = true
}

const saveEditedCategory = async () => {
  if (!editingCategoryName.value.trim() || !editingCategory.value || !editingCategory.value.id) {
    toast.error('Error: Categoría inválida')
    return
  }
  
  try {
    savingCategory.value = true
    
    await store.dispatch('categories/updateCategory', {
      id: editingCategory.value.id,
      data: { name: editingCategoryName.value.trim() }
    })
    
    // Recargar categorías después de la actualización
    await store.dispatch('categories/fetchCategories')
    
    showEditCategoryDialog.value = false
    editingCategory.value = null
    editingCategoryName.value = ''
    toast.success('Categoría actualizada exitosamente')
  } catch (error) {
    console.error('Error al actualizar categoría:', error)
    toast.error('Error al actualizar categoría: ' + (error.message || 'Error desconocido'))
  } finally {
    savingCategory.value = false
  }
}

const deleteCategoryConfirm = async (category) => {
  // Solo permitir eliminar categorías que tienen ID real del store
  if (!category.id) {
    toast.error('Esta categoría no se puede eliminar porque no está registrada en el sistema')
    return
  }
  
  const productCount = getProductCountByCategory(category.value)
  
  if (productCount > 0) {
    toast.error(`No se puede eliminar la categoría "${category.title}" porque tiene ${productCount} productos asociados`)
    return
  }
  
  const confirmed = confirm(`¿Estás seguro de que deseas eliminar la categoría "${category.title}"?`)
  
  if (confirmed) {
    try {
      await store.dispatch('categories/deleteCategory', category.id)
      
      // Recargar categorías después de la eliminación
      await store.dispatch('categories/fetchCategories')
      
      toast.success('Categoría eliminada exitosamente')
    } catch (error) {
      console.error('Error al eliminar categoría:', error)
      toast.error('Error al eliminar categoría: ' + (error.message || 'Error desconocido'))
    }
  }
}

// Cargar datos iniciales
onMounted(async () => {
  try {
    loading.value = true
    await Promise.all([
      store.dispatch('inventory/fetchInventory'),
      store.dispatch('products/fetchProducts'),
      store.dispatch('locations/fetchLocations'),
      store.dispatch('warehouses/fetchWarehouses'),
      store.dispatch('categories/fetchCategories').catch(() => {
        console.log('Categories not available, will be loaded on demand')
      })
    ])
    
    // Debug temporal: verificar que los productos se cargaron correctamente
    console.log('Productos cargados en el store:', productsFromStore.value)
    if (productsFromStore.value.length > 0) {
      console.log('Primer producto de ejemplo:', productsFromStore.value[0])
    }
    
    // Iniciar interval de actualización automática después de cargar los datos
    startInventoryUpdateInterval()
    
  } catch (error) {
    console.error('Error loading data:', error)
    toast.error('Error al cargar los datos: ' + (error.message || 'Error desconocido'))
  } finally {
    loading.value = false
  }
})

// Limpiar interval al salir de la vista
onUnmounted(() => {
  clearInventoryUpdateInterval()
})
</script>

<style scoped>
.inventario-container {
  padding: 20px;
}

.badge {
  padding: 5px 10px;
  border-radius: 20px;
  font-weight: 500;
}

.badge-warning {
  background-color: #f39c12;
  color: #fff;
}

.badge-info {
  background-color: #3498db;
  color: #fff;
}

.badge-success {
  background-color: #2ecc71;
  color: #fff;
}

.badge-danger {
  background-color: #e74c3c;
  color: #fff;
}

.dashboard-card {
  border-radius: 4px;
  box-shadow: var(--v-shadow-elevation-2);
  transition: transform 0.3s, box-shadow 0.3s;
}

.dashboard-card:hover {
  transform: translateY(-4px);
  box-shadow: var(--v-shadow-elevation-4);
}

.dashboard-value {
  font-size: 2rem;
  font-weight: 500;
  color: var(--v-primary-base);
  margin: 0.5rem 0;
}

.dashboard-subtitle {
  color: rgba(0, 0, 0, 0.6);
  font-size: 0.875rem;
}

.alert-card {
  background-color: var(--v-error-lighten4);
}

.alert-card .dashboard-value {
  color: var(--v-error-base);
}

.detail-group {
  margin-bottom: 1rem;
}

.detail-group label {
  font-weight: 500;
  color: rgba(0, 0, 0, 0.6);
  margin-bottom: 0.25rem;
  display: block;
}

.detail-group p {
  margin: 0;
}

.product-info {
  background-color: var(--v-surface-variant);
  padding: 1rem;
  border-radius: 4px;
}

.product-info h5 {
  margin: 0 0 0.5rem 0;
  color: var(--v-primary-base);
}

.product-info p {
  margin: 0.25rem 0;
}

.product-info .text-subtitle-2 {
  color: rgba(0, 0, 0, 0.6);
}

.pagination-container {
  font-size: 0.9rem;
}

.current-page {
  margin: 0 10px;
}

/* Estilos para la tabla de inventario */
.inventario-table {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background: white !important;
}

.inventario-table .v-data-table__thead {
  background-color: #f8f9fa !important;
}

.inventario-table .v-data-table__thead .v-data-table__th {
  background-color: #f8f9fa !important;
  font-weight: 600 !important;
  color: #495057 !important;
  border-bottom: 2px solid #dee2e6 !important;
  padding: 12px 16px !important;
  font-size: 0.875rem !important;
}

.inventario-table .v-data-table__tbody .v-data-table__td {
  padding: 12px 16px !important;
  border-bottom: 1px solid #dee2e6 !important;
}

.inventario-table .v-data-table__tbody tr:hover {
  background-color: #f8f9fa !important;
}

/* Estilos para filas de detalle de lote */
.lot-detail {
  padding-left: 20px;
  font-size: 0.875rem;
  color: #6c757d;
}

/* Estilos para filas de grupo de productos */
.inventario-table .v-data-table__tbody tr:has(.lot-detail) {
  background-color: #f8f9fa;
}

.inventario-table .v-data-table__tbody tr:has(.lot-detail):hover {
  background-color: #e9ecef !important;
}

/* Estilos para filas principales de grupo */
.inventario-table .v-data-table__tbody tr:has(.font-weight-bold) {
  background-color: #ffffff;
  border-left: 4px solid #2196f3;
}

.inventario-table .v-data-table__tbody tr:has(.font-weight-bold):hover {
  background-color: #e3f2fd !important;
}

/* Estilos para botones de expansión */
.inventario-table td[data-column="expand"] {
  min-width: 50px !important;
  width: 50px !important;
  padding: 8px !important;
}

/* Responsive - asegurar visibilidad en mobile */
@media (max-width: 768px) {
  .inventario-table td[data-column="expand"] {
    min-width: 40px !important;
    width: 40px !important;
    padding: 4px !important;
  }
  
  .inventario-table .v-btn {
    min-width: 32px !important;
    width: 32px !important;
    height: 32px !important;
  }
}

/* Estilos personalizados para separación de botones */
.d-flex.gap-6 .v-btn + .v-btn {
  margin-left: 24px !important;
}

/* Asegurar que los botones del header tengan espacio suficiente */
.create-product-btn {
  margin-right: 16px !important;
}

/* Estilos para botones de acción */
.action-buttons {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
  justify-content: center;
}

.action-buttons .v-btn {
  min-width: 32px;
}

/* Responsive */
@media (max-width: 768px) {
  .inventario-container {
    padding: 15px;
  }
  
  .dashboard-value {
    font-size: 1.5rem;
  }
  
  /* Header responsivo */
  .text-h4 {
    font-size: 1.5rem !important;
    margin-bottom: 12px;
  }
  
  .v-card-text {
    padding: 12px;
  }
  
  /* Filtros responsivos */
  .v-row .v-col {
    padding: 4px 8px;
  }
  
  .action-buttons {
    justify-content: flex-start;
    gap: 8px;
  }
  
  .action-buttons .v-btn {
    min-width: 36px;
    height: 36px;
  }
  
  /* Botones del header */
  .v-btn--size-small {
    min-width: 32px;
    height: 32px;
  }
}

@media (max-width: 480px) {
  .inventario-container {
    padding: 10px;
  }
  
  .dashboard-value {
    font-size: 1.25rem;
  }
  
  /* Header para móviles pequeños */
  .text-h4 {
    font-size: 1.25rem !important;
    margin-bottom: 8px;
  }
  
  .v-card {
    margin-bottom: 12px;
  }
  
  .v-card-text {
    padding: 8px;
  }
  
  /* Filtros para móviles pequeños */
  .v-text-field, .v-select {
    font-size: 12px;
  }
  
  .v-field__input {
    font-size: 12px;
  }
  
  /* Chips más pequeños */
  .v-chip {
    font-size: 10px;
    height: 20px;
  }
  
  .action-buttons .v-btn {
    min-width: 32px;
    height: 32px;
  }
  
  /* Botones del header más compactos */
  .v-btn {
    font-size: 11px;
    min-height: 28px;
  }
}
</style>
